import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { 
  ContactListPage, 
  ContactDetailPage,
} from './imports';

export const contactRoutes = [
  {
    path: 'contacts',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactListPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/:tab',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactDetailPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <ContactDetailPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
